import * as angular from 'angular';

export const ControllersModule = angular.module('app.controllers', []);
